export default __webpack_public_path__ + "82b83ae6e3668436f3f38fe8915bc7ba.svg";